export default __webpack_public_path__ + "static/media/Claims negotiator 2024.92c2842b.pdf";